const fetchEpisodes = async (filters) => {
  const filtersString = JSON.stringify(filters);
  const episodes = await fetch(inclusionData.ajax, {
    method: "POST",
    body: new URLSearchParams({
      action: "inclusion_load_episodes",
      filters: filtersString,
    }),
  });
  return await episodes.json();
};

export default fetchEpisodes;
